<template>
  <div class="container">
    <div class="themes-list">
      <div
        v-for="theme in themes"
        :key="theme.id"
        class="theme-item"
        @click="() => handleOnSelectTheme(theme)"
      >
        <div
          class="theme-wrapper"
          :class="
            selectedTheme && selectedTheme.id === theme.id ? 'selected' : ''
          "
        >
          <div class="theme-circle">
            <div
              class="theme-half-circle"
              :style="{ backgroundColor: theme.config.primary }"
            />
            <div
              class="theme-half-circle"
              :style="{ backgroundColor: theme.config.secondary }"
            />
          </div>
        </div>
        <p>{{ theme.title }}</p>
      </div>
      <div class="button-container">
        <loading-button
          @confirm="save"
          title="ذخیره پوسته"
          :loading="loading"
          :hasProgress="false"
        />
      </div>
    </div>
    <div class="preview">
      <div
        v-if="selectedTheme && selectedTheme.thumbnail"
        :style="{ backgroundImage: `url(${selectedTheme.thumbnail.url})` }"
        class="image"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingButton from "../../components/loading-button/LoadingButton.vue";
import productApiService from "../../services/api/ProductApiService";

export default {
  name: "SettingItem",
  components: { LoadingButton },
  data() {
    return {
      selectedTheme: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  watch: {
    item(item) {
      this.handleOnSelectTheme(item?.value || 1);
    },
  },
  methods: {
    getThemePreview() {},
    handleOnSelectTheme(theme) {
      this.selectedTheme = theme;
    },
    save() {
      this.loading = true;
      productApiService
        .storeOrEditShopSettings(
          this.item.id,
          this.selectedTheme.id,
          this.currentProvider.id
        )
        .then((result) => {
          this.$vs.notify({
            text: result.message,
            color: "success",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    const selectedTheme = this.themes.find(
      (el) => el.id === (this.item.value || 1)
    );
    this.handleOnSelectTheme(selectedTheme);
  },
  props: {
    themes: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  align-items: flex-start;
  padding: 14px 18px 28px;
  gap: 14px;
  max-width: none !important;

  @media screen and (max-width: 640px) {
    padding-top: 0;
    flex-direction: column;
  }

  .themes-list {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, auto);
    gap: 20px;
    margin: auto;
    border-radius: 10px;
    background-color: #f8f8f8;
    padding: 10px;

    @media (min-width: 640px) and (max-width: 850px) {
      grid-template-columns: repeat(3, auto);
    }

    @media (max-width: 480px) {
      grid-template-columns: repeat(3, auto);
    }

    @media screen and (max-width: 640px) {
      gap: 7px;
    }

    .theme-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      gap: 4px;
      cursor: pointer;

      p {
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        color: #232323;
      }

      .theme-wrapper {
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid transparent;
        padding: 2px;
        transform: rotate(-45deg);
        transition: 0.2s all ease-in-out;

        &.selected {
          border: 3px solid rgba(var(--vs-secondary), 1);
        }

        .theme-circle {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          overflow: hidden;

          .theme-half-circle {
            flex: 1;
          }
        }
      }
    }

    .button-container {
      grid-column: 1 / 5;
      margin-top: 12px;

      button {
        width: fit-content !important;
      }
    }
  }

  .preview {
    flex: 1;
    width: 100%;

    .image {
      width: 235px;
      height: 480px;
      margin: 0 auto;
      transition: 0.2s all ease-in-out;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>